import * as types from '../mutation-types'
import { getServiceDetail } from '../../plugins/util'
import { updateOrderInfo, downloadFile } from '../../utils/order'
var PromiseWorker = require('promise-worker')

const state = {
  isLoadingExceedsOrder: false,
  downloadWorker: null
}

// getters
const getters = {
  isLoadingExceedsOrder: (state) => state.isLoadingExceedsOrder
}

// actions
const actions = {
  exportExceedsOrder({ commit, dispatch }, data) {
    if (window.Worker) {
      const worker = new Worker('/assets/js/loadOrdersWorker.js')
      const promiseWorker = new PromiseWorker(worker)
      const {
        payload,
        limitedOrders,
        currentUserId,
        locale,
        localeSuffix,
        serviceTypes,
        fileFormat
      } = data
      let exceedsOrder = []

      commit(types.SET_LOADING_EXCEEDS_ORDER, true)
      commit(types.SET_DOWNLOAD_WORKER, worker)
      promiseWorker
        .postMessage(payload)
        .then((result) => {
          if (result && result.length > 0) {
            result.forEach((item) => {
              if (item.orders && item.orders.length > 0) {
                item.orders.forEach((order) => {
                  const service = getServiceDetail(serviceTypes, order.service_id)
                  // Update format data
                  updateOrderInfo(order, {
                    service,
                    locale,
                    currentUserId,
                    localeSuffix
                  })

                  if (!service) {
                    order.service_name = order.service_id
                  }

                  exceedsOrder.push(order)
                })
              }
            })

            let orders = []
            if (limitedOrders && limitedOrders.length > 0) {
              orders = limitedOrders.concat(exceedsOrder)
            }

            // pick custom fields
            // const dataToExport = pickOrderDataToExport(orders)
            dispatch('pickOrderDataToExport', orders).then((data) => {
              downloadFile(data, payload.data.params, fileFormat)
              commit(types.SET_LOADING_EXCEEDS_ORDER, false)
              commit(types.SET_DOWNLOAD_WORKER, null)
            })
          } else {
            commit(types.SET_LOADING_EXCEEDS_ORDER, false)
            commit(types.SET_DOWNLOAD_WORKER, null)
          }
        })
        .catch((err) => {
          commit(types.SET_LOADING_EXCEEDS_ORDER, false)
          commit(types.SET_DOWNLOAD_WORKER, null)
          console.error(err)
        })
    }
  },
  cancelExportExceedsOrder({ commit, state }) {
    const { downloadWorker } = state

    if (downloadWorker) {
      downloadWorker.terminate()
      commit(types.SET_DOWNLOAD_WORKER, null)
      commit(types.SET_LOADING_EXCEEDS_ORDER, false)
    }
  }
}

// mutations
const mutations = {
  [types.SET_LOADING_EXCEEDS_ORDER](state, isLoading) {
    state.isLoadingExceedsOrder = isLoading
  },
  [types.SET_DOWNLOAD_WORKER](state, worker) {
    state.downloadWorker = worker
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
